// extracted by mini-css-extract-plugin
module.exports = {"logSelect":"_2j-uWrDEusOxFYA46FGYcq"};